<script>
import PixabayDialog from "./PixabayDialog.vue";
import API from "../../API";
import Loading from "../common/loading.vue";

export default {
    name: "PixabayImageUpload",
    components: {Loading, PixabayDialog},
    props: {},
    data() {
        return {
            showDialog: false,
            loading: false
        }
    },
    computed: {
        translations() {
            return {
                buttonText: Lang.langGet('Add new stock image file'),
            }
        },
        api() {
            return new API('/content/mediapool/uploadExternal');
        }
    },
    methods: {
        onClose() {
            this.showDialog = false;
        },
        /** @param{PixabayImage[]} selectedImages  */
        async onConfirm(selectedImages) {
            this.loading = true;
            this.onClose();
            const data = selectedImages.map(image => {
                const {extension, name} = this.extractNameAndExtension(image.previewURL);
                return {
                    extension,
                    name,
                    url: image.largeImageURL
                }
            });

            const results = await Promise.all(
                data.map(async (item) => {
                    try {
                        const res = await this.api.post(item);
                        return { success: true, item, result: res };
                    } catch (err) {
                        return { success: false, item, error: err };
                    }
                })
            );

            const successes = results.filter(r => r.success);
            const failures  = results.filter(r => !r.success);

            if (failures.length) {
                console.warn(`Some uploads failed (${failures.length}/${results.length}).`, failures);
            }

            /** @type{PixabayUploadResponse[]} */
            const items = successes.map(s => s.result);

            this.loading = false;
            this.$emit('uploaded', items);
        },
        onOpen() {
            this.showDialog = true;
        },
        extractNameAndExtension(url) {
            if (!url) return {name: '', extension: ''};

            const filename = url.split('/').pop();

            const lastDotIndex = filename.lastIndexOf('.');
            if (lastDotIndex === -1) {
                return {name: filename, extension: ''};
            }

            const rawName = filename.slice(0, lastDotIndex);
            const extension = filename.slice(lastDotIndex);

            const cleanedName = rawName.replace(/_\d+$/, '');

            return {
                name: cleanedName,
                extension
            };
        }
    }
}
</script>

<template>
    <div>
        <v-btn
            :elevation="2"
            type="button"
            class="btn btn-primary"
            @click="onOpen">
            <v-icon left>far fa-plus</v-icon>
            {{ translations.buttonText }}
        </v-btn>
        <pixabay-dialog
            :show-dialog="showDialog"
            @close="onClose"
            @confirm="onConfirm"
        />
        <loading :loading="loading" />
    </div>
</template>
